export const L10N = {
  COUNTRY_LABEL: { id: 'core.label.country', defaultMessage: '　' },
  COUNTRY_PLACEHOLDER: { id: 'common.label.select', defaultMessage: '　' },
  CTA: { id: 'core.action.signup', defaultMessage: '　' },
  DATEOFBIRTH_LABEL: { id: 'core.label.date_of_birth', defaultMessage: '　' },
  DATEOFBIRTH_ERROR: { id: 'core.label.date_of_birth_error', defaultMessage: '　' },
  DESCRIPTION: { id: 'core.label.description_signup', defaultMessage: '　' },
  EMAIL_LABEL: { id: 'common.label.email', defaultMessage: '　' },
  FIRSTNAME_LABEL: { id: 'common.label.name', defaultMessage: '　' },
  LASTNAME_LABEL: { id: 'common.label.lastname', defaultMessage: '　' },
  LABEL_REQUIRED: { id: 'common.label.required', defaultMessage: '　' },
  PASSWORD_LABEL: { id: 'common.label.password', defaultMessage: '　' },
  PASSWORD_HINT: { id: 'core.label.password_hint', defaultMessage: '　' },
  PRIVACY_LABEL: { id: 'core.label.privacy_policy', defaultMessage: '　' },
  PRIVACY_CONDITIONS_LINK: { id: 'core.action.privacy_conditions' },
  PRIVACY_POLICY_LINK: { id: 'core.action.privacy_policy' },
  SUBSCRIBED_LABEL: { id: 'core.label.subscribe', defaultMessage: '　' },
  TITLE: { id: 'core.label.title_signup', defaultMessage: '　' },
  // Notifications
  SUCCESS_TITLE: { id: 'core.notification.signup_success', defaultMessage: '　' },
  SUCCESS_MESSAGE: { id: 'core.notification.email_sent_success', defaultMessage: '　' },
  NOTIFICATION_ERROR: { id: 'core.notification.validation_error', defaultMessage: '　' },
};
